export default __webpack_public_path__ + "static/media/store.e55d483a.jpg";